export default __webpack_public_path__ + "static/media/tab-slider-3.4334cab0.png";